export default __webpack_public_path__ + "maps-examples-tracking-mode-960-1f7f879229c9e366e3eaa41c3097f3dc.webp";